<!--Overrides @basecom-gmbh/pond/components/Cms/CmsElementCategoryNavigation.vue-->
<script setup lang="ts">
import type { CmsElementCategoryNavigation } from '@shopware-pwa/composables-next';
import type { Schemas } from '@shopware/api-client/api-types';
import CategoryNode from './CategoryNode.vue';

defineProps<{
    element: CmsElementCategoryNavigation;
}>();

const navigationStore = useNavigationStore();
const { mainNavigationElements } = storeToRefs(navigationStore);
await navigationStore.loadMainNavigation(5);

// IDS-95 show navigation only from second level
const { getCurrentSecondLevelNavigation } = useNavigationPathHelper();
const secondLevelNavigation = computed(() => {
    const elements: Schemas['NavigationRouteResponse'] | null = mainNavigationElements.value;
    if (!elements?.length) {
        return [];
    }

    const secondLevel = getCurrentSecondLevelNavigation(elements);

    return secondLevel.length ? secondLevel : mainNavigationElements.value;
});
</script>

<template>
    <ul
        v-if="secondLevelNavigation?.length"
        v-auto-animate
        class="hidden md:block"
    >
        <CategoryNode
            v-for="item in secondLevelNavigation"
            :key="item.id"
            :node="item"
            :depth="0"
        />
    </ul>
</template>
